import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Chrome extensions like MetaMask can inject scripts that throw page-level errors.
// They are not app errors, but CRA's dev overlay can display them as if they were.
window.addEventListener(
  "error",
  (event) => {
    const message = String(event?.message || event?.error?.message || "");
    const filename = String(event?.filename || "");
    if (message.includes("MetaMask") || filename.includes("chrome-extension://")) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const message = String(event?.reason?.message || event?.reason || "");
    if (message.includes("MetaMask") || message.includes("chrome-extension://")) {
      event.preventDefault();
    }
  },
  true
);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root was not found in public/index.html");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
